import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface SettingsDirtyContextValue {
  isDirty: boolean;
  setDirty: (dirty: boolean) => void;
}

const SettingsDirtyContext = createContext<SettingsDirtyContextValue>({
  isDirty: false,
  setDirty: () => {},
});

export function SettingsDirtyProvider({ children }: { children: ReactNode }) {
  const [isDirty, setIsDirty] = useState(false);
  const setDirty = useCallback((dirty: boolean) => setIsDirty(dirty), []);
  return (
    <SettingsDirtyContext.Provider value={{ isDirty, setDirty }}>
      {children}
    </SettingsDirtyContext.Provider>
  );
}

export function useSettingsDirty() {
  return useContext(SettingsDirtyContext);
}
